class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
     console.log('custome script for cart drawer', this.classList)
this.checkItems();
    document.body.classList.add('overflow-hidden');
  }

  checkItems(){
        let needToReload = false;

    const cartItemLinks = document.querySelectorAll('a.cart-item__name');
// cartItemLinks is a NodeList, which can be iterated over like an array
 const itemQuantities = getCartQuantities()
    console.log(itemQuantities)
    cartItemLinks.forEach((link,index) => {
      const variant = getVariantFromUrl(link.href);
                    console.log(link.innerHTML);
      const minPax = extractMinPax(link.innerHTML);
      console.log(minPax)
      const currentOrderQuantity = itemQuantities[index];
      if(variant && minPax&& currentOrderQuantity && minPax> currentOrderQuantity){
         console.log(" I am going to add more items here :) ", variant,  minPax - currentOrderQuantity );
        addItemToCart(variant, minPax - currentOrderQuantity);
        needToReload = true;
      }
});
    if(needToReload){
     setTimeout(()=>this.reloadComponent() , 1000) ;
    }
  }

   reloadComponent() {
    // Fetch the updated cart data
    fetch('/cart')
      .then(response => response.text())
      .then(html => {
        // Parse the HTML response to get the updated cart drawer content
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Get the updated cart drawer section
        const newCartDrawerContent = doc.querySelector('#CartDrawer').innerHTML;

        // Update the current cart drawer with the new content
        this.querySelector('#CartDrawer').innerHTML = newCartDrawerContent;

        // Reattach event listeners if needed
        this.setHeaderCartIconAccessibility();
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        // Trigger any animations or focus traps again if necessary
        this.open();
      })
      .catch(error => {
        console.error('Error reloading cart drawer:', error);
      });
  }
  

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function getVariantFromUrl(url) {
    // Extract the query string part of the URL
    const queryString = url.split('?')[1];
    
    // Check if there is a query string
    if (!queryString) return null;
    
    // Use URLSearchParams to parse the query string
    const params = new URLSearchParams(queryString);
    
    // Get the variant value
    return params.get('variant');
}
function extractMinPax(inputString) {
    // Regular expression to match the pattern "| Min xx pax"
    const regex = /\|\s*Min\s*(\d+)\s*pax/i;
    
    // Execute the regex on the input string
    const match = inputString.match(regex);
    
    // If a match is found, return the number; otherwise, return undefined
    return match ? parseInt(match[1], 10) : undefined;
}

function getCartQuantities() {
    const inputs = document.querySelectorAll('input.quantity__input');
    const quantities = Array.from(inputs).map(input => {
        const quantity = input.getAttribute('data-cart-quantity');
        return quantity !== null ? parseInt(quantity, 10) : null; // Using parseInt for integer conversion
    });

    return quantities;
}

function addItemToCart(variant, quantity) {
    const data = {
        id: variant,
        quantity: quantity
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then(data => {
        console.log('item added', data);
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });
}
